import { render, staticRenderFns } from "./CoozzyArrowLeftIcon.vue?vue&type=template&id=12d846d2&scoped=true"
import script from "./CoozzyArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyArrowLeftIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyArrowLeftIcon.vue?vue&type=style&index=0&id=12d846d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d846d2",
  null
  
)

export default component.exports